import { render, staticRenderFns } from "./fieldTab.vue?vue&type=template&id=6e48d776&scoped=true&"
import script from "./fieldTab.vue?vue&type=script&lang=js&"
export * from "./fieldTab.vue?vue&type=script&lang=js&"
import style0 from "./fieldTab.vue?vue&type=style&index=0&id=6e48d776&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e48d776",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e48d776')) {
      api.createRecord('6e48d776', component.options)
    } else {
      api.reload('6e48d776', component.options)
    }
    module.hot.accept("./fieldTab.vue?vue&type=template&id=6e48d776&scoped=true&", function () {
      api.rerender('6e48d776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settingPanel/fieldTab.vue"
export default component.exports